<template>
	<div>
		<div>
			<div class=" text-left" style="margin-bottom: 20px;" v-if="Object.keys(ms.lista).length>0">
				<el-carousel>
					<el-carousel-item v-for="(item, index) in ms.lista" :key="index">
						<h3 class="small">
							<img style="width: 100%; height: 100%;" :src="item.value_a" alt />
						</h3>
					</el-carousel-item>
				</el-carousel>
			</div>


			<el-row>
				<el-col :span="24">
					<div class="grid-content bg-purple-dark">
						<div class="row" style="padding-top: 20px; padding-bottom: 20px;">
							<div class="col-1"></div>
							<div class="col-11">
								<h4>{{list_b.title}}</h4>
								<h5 style="color: #c5114f; margin-top: 20px;">
									<div>{{list_b.classify_name}}</div>
								</h5>
								<h5 style="margin-top: 20px;">
									<el-tag v-for="(item, index) in list_b_biaoqian" :key="index" type="info"
										style="margin-right: 10px;">{{item}}</el-tag>
								</h5>
								<h5 style="margin-top: 20px;">
									<i class="el-icon-location"></i>{{list_b.address}}
								</h5>
							</div>
						</div>
					</div>
				</el-col>
			</el-row>


			<el-row v-if="Object.keys(ms.listb).length>0">
				<el-col :span="24">
					<div class="grid-content bg-purple-dark">
						<h4 class="h_hei" style="padding-top: 10px;">特惠专区</h4>
						<div class="row" style="padding:10px;">
							<div class="col-12">
								<img style="width: 100%;" :src="ms.listb[0].value_a" />
							</div>
						</div>
					</div>
				</el-col>
			</el-row>

			<el-row v-if="Object.keys(ms.listc).length>0">
				<el-col :span="24">
					<div class="grid-content bg-purple-dark">
						<h4 class="h_hei" style="padding-top: 10px;">户型图</h4>
						<div class="row" style="height: 400px;">
							<div class="col-12">
								<el-carousel style="height: 400px;">
									<el-carousel-item v-for="(item, index) in ms.listc" :key="index"
										style="height: 400px;">
										<h3 class="small">
											<img style="width: 100%; height: 100%;" :src="item.value_a" alt />
										</h3>
									</el-carousel-item>
								</el-carousel>
							</div>
						</div>
					</div>
				</el-col>
			</el-row>

			<el-row>
				<el-col :span="24">
					<div class="grid-content bg-purple-dark">
						<h4 class="h_hei" style="padding-top: 10px;">项目信息</h4>
						<div class="row">
							<div v-html="list_b.detailed"></div>
						</div>
					</div>
				</el-col>
			</el-row>


			<el-row v-if="Object.keys(ms.listd).length>0">
				<el-col :span="24">
					<div class="grid-content bg-purple-dark">
						<h4 class="h_hei" style="padding-top: 10px;">位置及周边</h4>
						<div class="row" style="width: 100%;">
							<div class="col-12" style="margin: 10px; line-height: 25px;">

								<div v-for="(item, index) in ms.listd" :key="index" style="margin-top: 10px;">
									<el-tag>{{item.key}}</el-tag>
									<div v-if="item.value_c=='0'">
										<img style="width: 100%;margin-top: 10px;" :src="item.value_a" />
									</div>
									<div v-else style="margin-top: 10px;">{{item.value_a}}</div>
								</div>

							</div>
						</div>
					</div>
				</el-col>
			</el-row>


		</div>


		<div class="grid-content bg-purple-dark" @click="add_order(list_b)">
			<h4 style=" text-align: center; line-height: 50px;">
				<i class="el-icon-user-solid"></i>
				在线咨询
			</h4>
		</div>


		<el-dialog title="在线咨询" :visible.sync="dialogToAdd" width="90%">
			<el-form :model="itemForm" style="margin-top: -20px; text-align: left;">
				<el-form-item label="姓名" label-position="left" style="text-align: left;">
					<el-input v-model="itemForm.name"></el-input>
				</el-form-item>
				<el-form-item label="电话" label-position="left" style="text-align: left;">
					<el-input v-model="itemForm.tel"></el-input>
				</el-form-item>
				<div style="text-align: right;" @click="add_ojb">
					<el-button type="primary">我要咨询</el-button>
				</div>
			</el-form>
		</el-dialog>









		<div style="line-height: 30px; text-align: center; margin-top: 30px; margin-bottom: 30px;">
			<div>汇聚台州房产媒体力量，搭建优质楼盘线上展厅</div>
			<div>为老百姓提供安心选房大平台</div>
			<div
				style="text-indent:2em; font-size: 12px; color: #C0C0C0; text-align: left; line-height: 20px; margin-top: 15px;">
				本网站所刊载的各类内容(包括但不仅限于文字、图片、图表)仅供参考使用，并不构成任何投资建议。对于访问者根据本网站提供的信息所做出的一切行为，本网站不承担任何责任。</div>
			<div style="margin-top: 20px;">Copyright © 2022 台州城市网</div>
		</div>

	</div>


	</div>
</template>

<script>
	export default {
		data() {
			return {
				ms: {
					lista: [],
					listb: [],
					listc: [],
					listd: [],
				},
				dialogToAdd: false,
				itemForm: {
					t1: "",
					t2: "",
					name: '',
					tel: '',
				},
				list_b: {},
				list_b_biaoqian: [],
				list_b_classify_name: "",
				tabPosition: 'top',
				usable: '1',
				tabs: [{
						name: '1',
						label: '品牌馆日'
					},
					{
						name: '2',
						label: '领取优惠'
					}
				]
			}
		},
		mounted() {
			this.ms.lista = [];
			this.ms.listb = [];
			this.ms.listc = [];
			this.ms.listd = [];

			this.lista()
		},
		methods: {
			handleClick(tab) {
				console.log(tab)
			},
			add_order() {
				//console.log(itm)
				//this.itemForm.t1 = itm.value_a
				//this.itemForm.t2 = itm.value_b
				//dialogToAdd
				this.dialogToAdd = true;
			},
			lista() {
				var id = this.$route.query.id;
				this.$api.getAPI("data/page/0?token=0&appid=20220425&type_id=202204251003&key_id=" + id, {}).then(
					res => {
						console.log(res.data)
						this.listb(id)
						if (res.data.code == 200) {
							var datas = res.data.data.models.detailedjson;
							//遍历全局数据
							for (var i = 0; i < datas.length; i++) {
								//如果等于1
								if (datas[i].id == 1) {
									this.ms.lista.push(datas[i])
								}
								//如果等于1
								if (datas[i].id == 2) {
									this.ms.listb.push(datas[i])
								}
								//如果等于1
								if (datas[i].id == 3) {
									this.ms.listc.push(datas[i])
								}
								//如果等于1
								if (datas[i].id == 4) {
									this.ms.listd.push(datas[i])
								}
							}

							console.log(this.ms)
							//this.list_a = datas;

						}
					})
			},
			listb(datas) {
				//var datas = this.$route.query.id;
				this.$api.getAPI("data/product/" + datas + "?token=0&appid=20220425&type_id=202204251002", {}).then(
				res => {
					console.log(res.data)
					if (res.data.code == 200) {
						var datas = res.data.data.models;
						this.list_b = datas
						this.list_b_biaoqian = datas.label.split(/\s+/);
						this.list_b_classify_name = "";

						this.itemForm.t1 = datas.title;
						this.itemForm.t2 = datas.classify_name;
						//list_b.classify_name
						console.log(this.list_b_biaoqian)
					}
				})
			},
			add_ojb() {
				if (this.itemForm.name.length < 1 || this.itemForm.tel < 8) {
					this.$Message.error("请认真填写个人资料！")
					return
				}
				let data = new FormData()
				data.append('title', this.itemForm.t1)
				data.append('describe', this.itemForm.t2)
				data.append('username', this.itemForm.name)
				data.append('openid', this.itemForm.name)
				data.append('telephone', this.itemForm.tel)
				this.$api.postAPI("mutual/reply/?token=0&appid=20220425&type_id=202204251004", data).then(res => {
					console.log(res.data)
					if (res.data.code == 200) {
						this.$Message.success("提交成功！")
						this.dialogToAdd = false;
						this.itemForm.name = "";
						this.itemForm.tel = "";

					}
				})
			}
		}
	}
</script>

<style>
	.header {
		height: 15rem;
		color: #fff;
		background: url("http://www.baiduhrb.com/fjh/images/user_bg.png");
		background-size: 100% 100%;
	}

	.header .logo {
		display: block;
		float: left;
		margin-left: .8rem;
		margin-top: -4rem;
	}

	.header .logo img {
		position: relative;
		overflow-x: hidden;
		width: 45%;
		height: auto;
		top: 0px;
	}

	.m-slider {
		overflow-x: hidden;
		position: relative;
		margin-top: -10rem;
		border-radius: .45em;
	}

	.zhibo {
		background: #c5114f;
		text-align: center;
		color: #fff;
	}

	.loupan {
		opacity: 0.6;
		background: #c5114f;
		text-align: center;
		color: #fff;
	}

	.jiage {
		background: #c5114f;
		text-align: center;
		color: #fff;
	}

	.h_hei {
		border-left: 5px solid #c5114f;
		padding-left: 5px;
	}

	.container-fluid {
		margin-top: 0px !important;
		max-width: 1200px;
	}

	.el-tabs__item {
		font-size: 16px !important;


	}

	.el-tabs__item is-top is-active {
		width: 50% !important;
	}

	.el-carousel__container {
		height: 200px !important;
	}





	.el-row {
		margin-bottom: 20px;

		&:last-child {
			margin-bottom: 0;
		}
	}

	.el-col {
		border-radius: 10px;
	}

	.bg-purple-dark {
		background-color: #fff;
		box-shadow: 1px 1px 1px #ccc;
	}

	.bg-purple {
		background: #d3dce6;
	}

	.bg-purple-light {
		background: #e5e9f2;
	}

	.grid-content {
		border-radius: 4px;
		min-height: 36px;
	}

	.row-bg {
		padding: 10px 0;
		background-color: #f9fafc;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/wyfc/wyfc_show.vue